import { render, staticRenderFns } from "./lancarRelatorioBNCCPage.vue?vue&type=template&id=b5b781ea&"
import script from "./lancarRelatorioBNCCPage.vue?vue&type=script&lang=js&"
export * from "./lancarRelatorioBNCCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports